import { render, staticRenderFns } from "./RegulationsLanding.vue?vue&type=template&id=6dbe6322&"
import script from "./RegulationsLanding.vue?vue&type=script&lang=js&"
export * from "./RegulationsLanding.vue?vue&type=script&lang=js&"
import style0 from "./RegulationsLanding.vue?vue&type=style&index=0&id=6dbe6322&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports